<template>
  <div>uer</div>
</template>

<script>
export default {
  name: "user"
}
</script>

<style scoped></style>
